import React from 'react';
import { Tree } from 'antd';
import Icon from 'components/Icon';
import BaseComponent from 'components/BaseComponent';
import { materialTitleObjMap } from '@/routes/Material/Util/components/materialUtil';
const { TreeNode } = Tree;

/* 素材树 */
export class MaterialTreeComponent extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            folderNodes: {},    // 所有文件夹节点
            floderNodesChange: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        const { folderNodes, floderNodesChange } = nextProps;
        if (this.state.nodeChange !== floderNodesChange) {
            this.setState({
                folderNodes: folderNodes,
                floderNodesChange: floderNodesChange,
            });
        }
    }
    
    /** 
     * 树选择切换
     * key: '素材类型-分享与否-folderId-共享素材' 
     * 是否分享 0:否 1:是
     * 共享素材: 0:查询自己分享的素材 1:查询别人共享的素材
     */
    onSelect = (keys) => {
        if (keys && keys.length <= 0) {
            return;
        }
        let key = keys[0];
        if (key === '-1') {
            return;
        }
        let keySplit = key.split("-");
        if (keySplit.length !== 4) {
            return;
        }
        let currentType = keySplit[0];
        let isShare = keySplit[1];
        let folderId = keySplit[2];
        let otherShare = keySplit[3];
        this.props.onChangeCurrentType({ currentType, isShare, otherShare}, folderId);
    }

    /** 文件夹树渲染 */
    getFolderTreeNode = (data) => {
        if (!data || data.length <= 0) {
            return null;
        }
        const { typeData: { currentType: defaultType, isShare, otherShare }, folderId } = this.props;
        let defaultKey = defaultType + "-" + isShare + "-" + folderId + "-" + otherShare;
        let folderTreeNode = data.map((item) => {
            let key = `${item.type}-0-${item.id}-0`;
            let checkStyle = "";
            if (key === defaultKey) {
                checkStyle = "material-checked";
            }
            if (item.children) {
                return (
                    <TreeNode className={checkStyle} icon={<Icon className="material-folder-o" />} title={item.name} key={key}>
                        {this.getFolderTreeNode(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode className={checkStyle} icon={<Icon className="material-folder-o" />} title={item.name} key={key} />;
        });
        return folderTreeNode;
    }

    render() {
        const { type, typeData: { currentType: defaultType, isShare, otherShare }, folderId, tabsType, userFolderId } = this.props;
        let { folderNodes } = this.state;
        let treeData = {};
        if (!type || type.length <= 0) {
            return null;
        }

        let defaultKey = defaultType + "-" + isShare + "-" + folderId + "-" + otherShare;
        /** 
         * 0:视频 1:图片 2:音乐 7:网页
         * 15:Word 16:Excel 17:PPT 35:PDF
         * 18:RSS
         */
        let allTreeNode = type.map((currentType) => {
            let key = `${currentType}-0-${userFolderId}-0`;
            treeData[type] = materialTitleObjMap.get(currentType);
            let folderTreeNode = null;
            if (tabsType === '0') {
                let data = folderNodes[currentType];
                folderTreeNode = this.getFolderTreeNode(data);
            } else {
                key = `${currentType}-1-${userFolderId}-1`;
            }
            let shareKey = `${currentType}-1-${userFolderId}-0`;
            let checkStyle = "";
            let shareCheckStyle = "";
            if (defaultKey === key) {
                checkStyle = "material-checked";
            } else if (defaultKey === shareKey) {
                shareCheckStyle = "material-checked";
            }
            return (
                <TreeNode className={checkStyle} icon={<Icon className={treeData[type].treeIcon} />} title={treeData[type].title} key={key}>
                    { tabsType === '0' ? 
                    <TreeNode className={shareCheckStyle} icon={<Icon className="share-o" />} title={window.language['material.myShare']} key={shareKey} />
                    : null }
                    {folderTreeNode}
                </TreeNode>
            )
        });


        return (
            <Tree
                showIcon
                showLine
                defaultExpandedKeys={['-1']}
                switcherIcon={<Icon className="down-arrow-o" />}
                className="material-tree-style"
                onSelect={this.onSelect}
            >
                <TreeNode icon={<Icon className="material-folder-o" />} title={window.language['material.allFiles']} key="-1">
                    { allTreeNode }
                </TreeNode>
            </Tree>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/materialTreeComponent.js